import { AxiosResponse } from "axios";
import { IGetResponse, IListResponse } from "../../../models/Api";
import {
  CreateQuoteRequestServiceOpts,
  CreateQuoteRequestStatusOpts,
  ListQuoteRequestServicesOpts,
  ListQuoteRequestStatusOpts,
  QuoteRequest,
  QuoteRequestService,
  QuoteRequestStatus,
  SearchableQuoteRequestsFilterInput,
  UpdateQuoteRequestOpts,
  UpdateQuoteRequestServiceOpts,
  UpdateQuoteRequestStatusOpts,
} from "../../../models/Api/QuoteRequests";
import { axiosInstance } from "../../../../../axiosInstance";

export const listQuoteRequests = async (
  buildingId: string,
  offset: number,
  limit: number,
  filter?: SearchableQuoteRequestsFilterInput
): Promise<AxiosResponse<IListResponse<QuoteRequest>>> => {
  const params = {
    offset,
    limit,
  };

  if (filter) {
    const keys = Object.keys(filter);
    keys.forEach(key => {
      const operator = Object.keys(filter[key]);
      if (operator) {
        const value = filter[key][operator];
        if (operator.includes("between")) {
          value.forEach((val: string, index: number) => {
            params[`${key}[${operator}][${index}]`] = val;
          });
        } else {
          if (value !== null && value !== "" && value !== undefined) {
            params[`${key}[${operator}]`] = value;
          }
        }
      }
    });
  }

  return axiosInstance.get(`/quote_requests/buildings/${buildingId}`, {
    params,
  });
};

export const getQuoteRequest = async (
  id: string
): Promise<AxiosResponse<IGetResponse<QuoteRequest>>> => {
  return axiosInstance.get(`/quote_requests/${id}`);
};

export const updateQuoteRequest = async ({
  id,
  ...payload
}: UpdateQuoteRequestOpts): Promise<
  AxiosResponse<IGetResponse<QuoteRequest>>
> => {
  return axiosInstance.put(`/quote_requests/${id}`, payload);
};

export const deleteQuoteRequest = async (
  id: number
): Promise<AxiosResponse<IGetResponse<QuoteRequest>>> => {
  return axiosInstance.delete(`/quote_requests/${id}`);
};

export const listQuoteRequestStatus = async (
  payload: ListQuoteRequestStatusOpts | undefined
): Promise<AxiosResponse<IListResponse<QuoteRequestStatus>>> => {
  return axiosInstance.get("/quote_requests/status", { params: payload });
};

export const getQuoteRequestStatus = async (
  id: string
): Promise<AxiosResponse<IGetResponse<QuoteRequestStatus>>> => {
  return axiosInstance.get(`/quote_requests/status/${id}`);
};

export const createQuoteRequestStatus = async (
  payload: CreateQuoteRequestStatusOpts
): Promise<AxiosResponse<IGetResponse<QuoteRequestStatus>>> => {
  return axiosInstance.post("/quote_requests/status", payload);
};

export const updateQuoteRequestStatus = async (
  payload: UpdateQuoteRequestStatusOpts
): Promise<AxiosResponse<IGetResponse<QuoteRequestStatus>>> => {
  const { id, ...params } = payload;

  return axiosInstance.put(`/quote_requests/status/${id}`, params);
};

export const deleteQuoteRequestStatus = async (
  id: number
): Promise<AxiosResponse<IGetResponse<QuoteRequestStatus>>> => {
  return axiosInstance.delete(`/quote_requests/status/${id}`);
};

export const listQuoteRequestServices = async (
  payload: ListQuoteRequestServicesOpts | undefined
): Promise<AxiosResponse<IListResponse<QuoteRequestService>>> => {
  return axiosInstance.get("/quote_requests/services", { params: payload });
};

export const getQuoteRequestService = async (
  id: string
): Promise<AxiosResponse<IGetResponse<QuoteRequestService>>> => {
  return axiosInstance.get(`/quote_requests/services/${id}`);
};

export const createQuoteRequestService = async (
  payload: CreateQuoteRequestServiceOpts
): Promise<AxiosResponse<IGetResponse<QuoteRequestService>>> => {
  return axiosInstance.post("/quote_requests/services", payload);
};

export const updateQuoteRequestService = async (
  payload: UpdateQuoteRequestServiceOpts
): Promise<AxiosResponse<IGetResponse<QuoteRequestService>>> => {
  const { id, ...params } = payload;

  return axiosInstance.put(`/quote_requests/services/${id}`, params);
};

export const deleteQuoteRequestService = async (
  id: number
): Promise<AxiosResponse<IGetResponse<QuoteRequestService>>> => {
  return axiosInstance.delete(`/quote_requests/services/${id}`);
};
